import { Box, Typography } from '@mui/material'
import { IQuestionnaireSection, IVesselFile } from '~api/vessels/read'
import ConfirmModal from '~components/molecules/modal/confirm-modal/confirm-modal'
import { Field } from './open-section-modal'

export function DeleteConfirmation({
  onConfirm,
  onCancel,
  section,
  filesToDelete,
  inputData,
}: {
  onConfirm: () => void
  onCancel: () => void
  section: IQuestionnaireSection
  filesToDelete?: IVesselFile[]
  inputData?: Field[]
}) {
  const commentsToDelete = inputData?.filter((i) => i.comment === null)

  return (
    <ConfirmModal isVisible onConfirm={onConfirm} onCancel={onCancel}>
      <Box sx={{ textAlign: 'left' }}>
        {!!filesToDelete?.length && (
          <>
            <Typography variant="paragraph2">{`You are deleting the following ${filesToDelete?.length === 1 ? 'file:' : ' files:'}`}</Typography>
            <Box sx={{ pl: 3, my: 2 }} component="ul">
              {filesToDelete?.map((file) => (
                <li key={file.etag}>
                  <Typography variant="paragraph2">{file.filename}</Typography>
                </li>
              ))}
            </Box>
          </>
        )}

        {!!commentsToDelete?.length && (
          <>
            <Typography variant="paragraph2">{`You are deleting the ${commentsToDelete?.length === 1 ? 'comment' : ' comments'} for:`}</Typography>
            <Box sx={{ pl: 3, my: 2 }} component="ul">
              {commentsToDelete?.map((item, i) => (
                <li key={item.id}>
                  <Typography variant="paragraph2">
                    {section.fields.find((s) => s.id === item.id)?.name}
                  </Typography>
                </li>
              ))}
            </Box>
          </>
        )}
      </Box>
    </ConfirmModal>
  )
}
